import * as ReactDOM from 'react-dom/client';
import 'config/i18n';
import App from './App';
import './index.css';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOM.createRoot(container!);
root.render(<App />);
